import Model from '@/models/Model'

class CountryGroup extends Model {
  get schema () {
    return [
      'id',
      'name',
      'countryCodes'
    ]
  }
}

export default CountryGroup
